module.exports = __webpack_public_path__ + "static/media/header_slide_04.1cd8d2de.jpg";